import { fromJS } from 'immutable';
import * as actions from '../utils/Constants';


export default (state = getInitialState(), action) => {
    switch (action.type) {

        case actions.GET_PERSON + actions.FULFILLED:
            {
                return state.set('person', fromJS(action.payload));
            }
        case actions.GET_EDIT_CONTACT_DETAILS + actions.FULFILLED:
        {
            return state.set('editContactDetails', action.payload)
            }
        case actions.CLEAR_EDIT_CONTACT_DETAILS:
            {
                return state.set('editContactDetails', fromJS([]))
            }
        case actions.SAVE_PERSON + actions.FULFILLED:
        case actions.UPDATE_PERSON:
            {
                return state.set('person', fromJS(action.payload));
            }
        case actions.UPDATE_RATE_FIELD:
            {
                return state.setIn(['person', 'dailyRate'], fromJS(action.payload));
            }
        case actions.CLEAR_PERSON:
            {
                return getInitialState();
            }
        case actions.FROM_ADD_BUTTON:
            {
                return state.set('fromAddButton', fromJS(action.payload || {})); // Clears if payload is null/undefined
            }
        case actions.TOGGLE_PERSON_CONTACT_NAME_IS_VALID: {
            return state.set('contactNameIsValid', action.payload);
        }
        case actions.SAVE_USER + actions.FULFILLED:
            {
                return state.withMutations(state => {
                    const { person, ...user } = action.payload;
                    state.set('user', fromJS(user));
                });
            }
        case actions.GET_USER + actions.FULFILLED:
            {
                return state.withMutations(state => {
                    const { person, ...user } = action.payload;
                    state.set('person', fromJS(person));
                    state.set('user', fromJS(user));
                });
            }

        case actions.ADD_PERSON_DOCUMENT + actions.FULFILLED:
        case actions.DELETE_PERSON_DOCUMENTS + actions.FULFILLED:
        case actions.GET_PERSON_DOCUMENTS + actions.FULFILLED:
            {
                return state.set('documents', fromJS(action.payload));
            }

        case actions.GET_PERSON_JOURNAL + actions.FULFILLED:
        case actions.ADD_UPDATE_PERSON_JOUNALENTRY + actions.FULFILLED:
        case actions.DELETE_PERSON_JOUNALENTRIES + actions.FULFILLED:
            return state.set('journal', fromJS(action.payload));

        case actions.SAVE_PERSON_PHONES + actions.FULFILLED:
        case actions.DELETE_PERSON_PHONES + actions.FULFILLED:
        case actions.GET_PERSON_PHONES + actions.FULFILLED:
            return state.set('phones', fromJS(action.payload));

        case actions.GET_PERSON_TRAININGS + actions.FULFILLED:
            return state.set('trainings', fromJS(action.payload));

        case actions.SAVE_PERSON_ADDRESS + actions.FULFILLED:
        case actions.DELETE_PERSON_ADDRESSES + actions.FULFILLED:
        case actions.GET_PERSON_ADDRESSES + actions.FULFILLED:
            return state.set('addresses', fromJS(action.payload));

        case actions.SAVE_PERSON_EMAILS + actions.FULFILLED:
        case actions.DELETE_PERSON_EMAILS + actions.FULFILLED:
        case actions.GET_PERSON_EMAILS + actions.FULFILLED:
            return state.set('emails', fromJS(action.payload));

        case actions.NEW_CONTACT:
            return getInitialState().setIn(['person', 'personTypeId'], action.payload);

        case actions.ADD_USER_CLAIM:
            return state.updateIn(['user', 'claims'], claims =>
                claims.push(
                    fromJS({
                        userId: state.get('userId'),
                        claimType: "ACT.NADCP",
                        claimValue: action.payload.toLowerCase()
                    })));

        case actions.REMOVE_USER_CLAIM:
            return state.updateIn(['user', 'claims'], claims => claims.filter(claim => claim.get('claimValue').toLowerCase() !== action.payload.toLowerCase()));

        case actions.UPDATE_USER_ROLE:
            return state.setIn(['user', 'userRoles'], fromJS([{ roleId: action.payload }]));

        case actions.UPDATE_USER_PASSWORD + actions.FULFILLED:
            return state.withMutations(mut => {
                const validationMessages = fromJS(action.payload);
                mut.set('passwordValidationMessages', validationMessages);
                mut.set('showPasswordChangeModal', validationMessages.size > 0);
                return mut;
            });

        case actions.TOGGLE_PASSWORD_CHANGE_MODAL: {
            return state.withMutations(mut => {
                mut.set('passwordValidationMessages', fromJS([]));
                mut.set('showPasswordChangeModal', !state.get('showPasswordChangeModal'));
                return mut;
            });
        }

        case actions.ADD_PERSON_DISCIPLINE: {
            return state.updateIn(['person', 'disciplines'], disciplines => {
                const index = disciplines.findIndex(x => x.get('disciplineId') === Number(action.payload));

                if (index !== -1)
                    return disciplines.update(index, discipline => discipline.set('isActive', true));
                else
                    return disciplines.push(fromJS({ disciplineId: action.payload, isActive: true }));

            });
        }

        case actions.REMOVE_PERSON_DISCIPLINE: {
            return state.updateIn(['person', 'disciplines'], disciplines => {
                const index = disciplines.findIndex(x => x.get('disciplineId') === Number(action.payload));

                if (index !== -1)
                    return disciplines.update(index, discipline => discipline.set('isActive', false));
                else
                    return disciplines;
            });
        }


        case actions.ADD_PERSON_COURTTYPE: {
            return state.updateIn(['person', 'courtTypes'], courtTypes => {
                const index = courtTypes.findIndex(x => x.get('courtTypeId') === Number(action.payload));

                if (index !== -1)
                    return courtTypes.update(index, courtType => courtType.set('isActive', true));
                else
                    return courtTypes.push(fromJS({ courtTypeId: action.payload, isActive: true }));

            });
        }

        case actions.REMOVE_PERSON_COURTTYPE: {
            return state.updateIn(['person', 'courtTypes'], courtTypes => {
                const index = courtTypes.findIndex(x => x.get('courtTypeId') === Number(action.payload));

                if (index !== -1)
                    return courtTypes.update(index, courtType => courtType.set('isActive', false));
                else
                    return courtTypes;
            });
        }

        case actions.ADD_PERSON_COMMITTEEASSIGNMENT: {
            return state.updateIn(['person', 'committeeAssignments'], committeeAssignments => {
                const index = committeeAssignments.findIndex(x => x.get('committeeAssignmentId') === action.payload);

                if (index !== -1)
                    return committeeAssignments.update(index, committeeAssignment => committeeAssignment.set('isActive', true));
                else
                    return committeeAssignments.push(fromJS({ committeeAssignmentId: action.payload, isActive: true }));

            });
        }

        case actions.REMOVE_PERSON_COMMITTEEASSIGNMENT: {
            return state.updateIn(['person', 'committeeAssignments'], committeeAssignments => {
                const index = committeeAssignments.findIndex(x => x.get('committeeAssignmentId') === action.payload);

                if (index !== -1)
                    return committeeAssignments.update(index, committeeAssignment => committeeAssignment.set('isActive', false));
                else
                    return committeeAssignments;
            });
        }

        case actions.UPDATE_PERSON_TYPE: {
            return state.setIn(['person', 'personTypeId'], action.payload);
        }

        case actions.SET_USER_ACTIVESTATUS: {
            return state.setIn(['user', 'isActive'], action.payload);
        }

        default:
            return state;
    }
}

const getInitialState = () => {
    return fromJS({
        person: {
            isActive: true,
            courtTypes: [],
            disciplines: [],
            dailyRate: ''
        },
        contactNameIsValid: false,
        addresses: [],
        documents: [],
        emails: [],
        journal: [],
        phones: [],
        trainings: [],
        user: {
            claims: [],
        },
        showPasswordChangeModal: false,
        passwordValidationMessages: []
    });
};